






















import { snackbar } from '../services/GlobalSnackbarService'

export default {
  name: 'GlobalSnackbar',
  data() {
    return {
      snackbar,
    }
  }
}
